import agent from './agent';
import program from './program';

export default { program, agent };
